<template>
    <BasePopUp v-if="showModal" @detailsClosed="onCancel">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{ title }}</h4>   
            <h6 class="text-center mt-2">{{ message }}</h6>             
            <div class="d-flex justify-content-center gap-3 mt-4 mb-4">
                <CButton type="button" color="secondary" @click="onCancel">{{ $t('cancel') }}</CButton>
                <CButton type="button" color="primary" @click="onConfirm">{{ $t('confirmPopUp') }}</CButton>
            </div>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { CButton } from '@coreui/vue';

export default {
    extends: BasePopUp,
    components: { BasePopUp, CButton },
    model: {
        prop: 'showModal',
        event: 'closeConfirmRequested'
    },
    methods: {
        onCancel() {
            this.$emit("cancel");
            this.$emit("closeConfirmRequested", false);
        },
        onConfirm() {
            this.$emit("confirm");
            this.$emit("closeConfirmRequested", false);
        }
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    }
    
    .gap-3 {
        gap: 1rem;
    }
</style>

